export const hi = {
    // Header
    'header.title': '🎭 कीन बेनकाब',
    'header.subtitle': 'Tom Kean Jr. (NJ-7) — आपकी स्वास्थ्य सेवा की परवाह नहीं करते।',

    // Hero Section
    'hero.quote': 'Tom Kean Jr.: "मैं मतदाताओं से कहता हूं कि मैं स्वतंत्र हूं। फिर मैं MAGA के साथ वोट करता हूं।"',
    'hero.subtext': '4 रिपब्लिकन ने ACA सब्सिडी बचाने के लिए पार्टी से अलग हुए। 17 दिसंबर को, 4 GOP विधायकों ने साहस दिखाया और वोट के लिए डेमोक्रेट्स के साथ जुड़े। Tom Kean Jr. (NJ-7)? वह चुप रहे। दिसंबर में, Kean ने ACA सब्सिडी बढ़ाने के लिए 17 रिपब्लिकन सीनेटरों के साथ GOP के आह्वान पर अपना नाम जोड़ा — लेकिन फिर भी उसने हाउस रिपब्लिकनों के साथ मिलकर विस्तार को रोकने के लिए वोट दिया। 2.2 करोड़ अमेरिकियों को 1 जनवरी से 114% प्रीमियम वृद्धि का सामना करना पड़ेगा।',

    // Breaking News
    'breaking.news': '🚨 ब्रेकिंग: CNN: अमेरिकी स्वास्थ्य देखभाल पर पहले से कहीं अधिक खर्च कर रहे हैं',

    // Kean Did Not Support Section
    'kean.betrayal.title': 'TOM KEAN JR. ने आपके लिए खड़े होने से मना किया',
    'kean.betrayal.text': '17 दिसंबर को, 4 रिपब्लिकन (Brian Fitzpatrick, Rob Bresnahan Jr., Ryan Mackenzie PA से, और Mike Lawler NY से) ने अपनी पार्टी से अलग होकर ACA सब्सिडी विस्तार पर वोट के लिए डेमोक्रेट्स का साथ दिया। Rep. Tom Kean Jr. (NJ-7) उनमें से नहीं थे। उन्होंने आपकी स्वास्थ्य देखभाल की बजाय पार्टी वफादारी चुनी।',
    'kean.betrayal.comparison': 'इन 4 रिपब्लिकन ने साहस दिखाया। Kean ने कायरता दिखाई।',
    'kean.betrayal.cta': 'Kean से पूछें: आपने हमारे लिए क्यों नहीं खड़े हुए?',

    // Healthcare Context Section
    'context.title': 'रिपब्लिकन को आपकी स्वास्थ्य देखभाल की परवाह नहीं है: "स्वास्थ्य लागत की सुनामी" अब हमारे सामने है',
    'context.intro': 'रिपब्लिकन कांग्रेसमैन Tom Kean Jr. (NJ-7) ने आपकी स्वास्थ्य देखभाल का समर्थन करने के लिए कुछ नहीं किया है। हर चीज के लिए अधिक भुगतान करने के लिए तैयार हो जाइए: प्रीमियम, डॉक्टर की यात्राएं, दवाइयां। आप यह सब कैसे वहन करेंगे? 16 दिसंबर को, हाउस रिपब्लिकन ने ACA सब्सिडी बढ़ाने के डेमोक्रेटिक प्रयास को खारिज कर दिया। डेमोक्रेट आपकी स्वास्थ्य देखभाल के लिए लड़ रहे हैं — ACA पारित करके, प्रमुख दवाओं की कीमतें कम करके, और भी बहुत कुछ। लेकिन Tom Kean Jr. ने इन सुरक्षाओं को समाप्त होने देने के लिए अपनी पार्टी के साथ मतदान किया।',
    'context.truth.title': 'सच्चाई: NJ परिवारों पर वास्तविक प्रभाव',
    'context.truth.text': 'माहवाह, NJ की निवासी टीना जंप को पता चला कि उनका ACA प्रीमियम <strong>$400/महीने से बढ़कर $1,100/महीने से अधिक</strong> हो जाएगा — लगभग तीन गुना वृद्धि। "मुझे नहीं पता कि मैं इसका भुगतान कैसे करूंगी," उन्होंने CBS News को बताया।',
    'context.impact': '<strong>2.2 करोड़ अमेरिकी</strong> जो टैक्स क्रेडिट के लिए योग्य हैं, अब कठिन वित्तीय निर्णयों का सामना कर रहे हैं। जेब से प्रीमियम लागत <strong>औसतन 114%</strong> बढ़ जाएगी, वार्षिक लागत $1,016 बढ़ जाएगी। $75,000/वर्ष कमाने वाला चार लोगों का परिवार अतिरिक्त <strong>$3,368</strong> प्रीमियम वृद्धि देख सकता है।',
    'context.tsunami': '"हम 1 जनवरी को स्वास्थ्य लागत की सुनामी देखेंगे," कम्युनिटी कैटालिस्ट की मिशेल स्टर्नथल ने कहा। कांग्रेसनल बजट ऑफिस के अनुसार, लगभग <strong>40 लाख लोग अपना स्वास्थ्य बीमा छोड़ सकते हैं</strong> उच्च प्रीमियम के कारण।',
    'context.exposed.title': 'बेनकाब: सबसे कमजोर कौन है?',
    'context.exposed.text': 'छोटे व्यवसाय मालिक और स्व-नियोजित कर्मचारी विशेष रूप से जोखिम में हैं। ACA में नामांकित लगभग आधे वयस्क छोटे व्यवसाय मालिक हैं, 25 से कम कर्मचारियों वाली कंपनियों में कार्यरत हैं, या स्व-नियोजित हैं।',
    'context.accountability': 'Rep. Tom Kean Jr. (NJ-7) ने अपनी पार्टी के साथ इन सब्सिडी को समाप्त होने देने के लिए वोट दिया। कांग्रेस के डेमोक्रेट ACA प्रीमियम टैक्स क्रेडिट के विस्तार पर वोट के लिए डिस्चार्ज याचिका दायर कर रहे हैं। हाउस जीतने का रास्ता सीधे न्यू जर्सी से होकर जाता है। उन्हें जवाबदेह ठहराने का समय आ गया है।',
    'context.cta': 'अभी कार्रवाई करें',

    // ACA Section
    'aca.title': 'रिपब्लिकन आपकी स्वास्थ्य देखभाल छीन रहे हैं — ACA सब्सिडी 31 दिसंबर को समाप्त हो चुकी है',
    'aca.text': 'हाउस रिपब्लिकन ने 16 दिसंबर को ACA सब्सिडी के विस्तार को रोक दिया। 1 जनवरी से, प्रीमियम औसतन 114% बढ़ जाएगा। कुछ परिवार, जैसे $72,000/वर्ष कमाने वाला माहवाह निवासी, लागत लगभग तीन गुना देखेगा — $400 से $1,100 प्रति माह से अधिक। Rep. Tom Kean Jr. (NJ-7) ने अपनी पार्टी के साथ इस जीवन रेखा को रोकने के लिए वोट दिया।',
    'aca.chart.title': 'औसत प्रीमियम वृद्धि',
    'aca.chart.2025': '2025',
    'aca.chart.2026': '2026',
    'aca.chart.withSubsidies': 'सब्सिडी के साथ',
    'aca.chart.increase': '+114% औसत',

    // No Kean Day Section
    'nokean.title': 'नो कीन डे!',
    'nokean.date': 'हर महीने की 7 तारीख।',
    'nokean.message': 'उन्हें संदेश भेजें!',
    'nokean.standup': 'स्वास्थ्य देखभाल के लिए खड़े हों',
    'nokean.handle': '@CongressmanKean',
    'nokean.caption': '"मैं टाउन हॉल से बचता हूं क्योंकि आईने मुझे असहज करते हैं।"',

    // Voting Record Section
    'voting.title': '📜 रसीदें स्पष्ट हैं',
    'voting.record.title': 'टॉम कीन जूनियर का वोटिंग रिकॉर्ड',
    'voting.bill.name': 'H.R.1 - वन बिग ब्यूटीफुल बिल एक्ट',
    'voting.bill.congress': '119वीं कांग्रेस (2025-2026) | पब्लिक लॉ 119-21',
    'voting.bill.rollcall': 'रोल कॉल वोट #145 | 22 मई, 2025',
    'voting.bill.cut1': '• ACA सब्सिडी में कटौती - 174% प्रीमियम वृद्धि',
    'voting.bill.cut2': '• मेडिकेड फंडिंग में कमी जो NJ परिवारों को प्रभावित करती है',
    'voting.breakdown.title': 'वोट विवरण',
    'voting.breakdown.yeas': '✓ पक्ष में: 215 (सभी रिपब्लिकन)',
    'voting.breakdown.nays': '✗ विपक्ष में: 214 (सभी डेमोक्रेट)',
    'voting.breakdown.present': 'उपस्थित: 1',
    'voting.breakdown.notvoting': 'वोट नहीं किया: 2',
    'voting.breakdown.passed': 'पारित',
    'voting.kean.name': 'टॉम कीन जूनियर',
    'voting.kean.title': 'प्रतिनिधि, NJ-7',
    'voting.kean.vote': 'हां',
    'voting.kean.result': 'स्वास्थ्य देखभाल में कटौती के लिए वोट दिया',
    'voting.source': 'स्रोत: यू.एस. हाउस ऑफ रिप्रेजेंटेटिव्स क्लर्क का कार्यालय | clerk.house.gov/Votes/2025145',
    'voting.cta.vote': 'कीन का वोट देखें',
    'voting.cta.bill': 'बिल पढ़ें (H.R.1)',

    // Medicaid Section
    'medicaid.title': 'Tom Kean Jr.: "मैं इसे \'वित्तीय जिम्मेदारी\' कहता हूं"',
    'medicaid.text': 'Rep. Tom Kean Jr. (NJ-7) ने मेडिकेड में कटौती का समर्थन किया जो वरिष्ठों, बच्चों और विकलांग लोगों को खतरे में डालती है। ये कटौती डॉक्टरों, अस्पतालों और दीर्घकालिक देखभाल तक पहुंच कम करती है। हर वोट सच बोलता है — भले ही वह न बोले।',
    'medicaid.visual': 'मेडिकेड = जीवन रेखा',
    'medicaid.hashtags': '#कीनबेनकाब #पैसेकापीछाकरो',
    'medicaid.hashtags.text': '#कीनबेनकाब #पैसेकापीछाकरो #रिपब्लिकनकोपरवाहनहीं',

    // Medicare Section
    'medicare.title': 'Tom Kean Jr.: "मैंने अपनी आवाज नहीं खोई। मैंने इसे ट्रंप को दे दी।"',
    'medicare.subtext': 'रिपब्लिकन प्रस्तावों में सैकड़ों अरबों डॉलर की मेडिकेयर कटौती शामिल है। Rep. Tom Kean Jr. (NJ-7) ने इन प्रयासों के साथ गठबंधन किया है, जो वरिष्ठों की स्वास्थ्य देखभाल को खतरे में डालता है।',
    'medicare.bullet1': 'GOP बजट ड्राफ्ट मेडिकेयर में $479 बिलियन की कटौती प्रस्तावित करते हैं (भुगतान संरचनाएं, पात्रता परिवर्तन)।',
    'medicare.bullet2': '"वन बिग ब्यूटीफुल बिल एक्ट" में मेडिकेयर पहुंच को प्रतिबंधित करने वाले प्रावधान शामिल थे।',
    'medicare.bullet3': 'NJ-7 के वरिष्ठ अस्पताल यात्राओं, नुस्खों और दीर्घकालिक देखभाल के लिए मेडिकेयर पर निर्भर हैं।',
    'medicare.cta': 'मेडिकेयर की रक्षा करें — कार्रवाई करें',
    'medicare.visual': 'मेडिकेयर = जीवन रेखा।\nकार्रवाई करने के लिए QR कोड स्कैन करें।',

    // Accountability Section
    'accountability.title': 'मुखौटा उतर गया। Tom Kean Jr. को जवाबदेह ठहराएं।',
    'accountability.text': '"कभी-कभी मौन सोना नहीं होता। यह सावधानी के वेश में कायरता है।" Rep. Tom Kean Jr. (NJ-7) का रिकॉर्ड स्पष्ट है: अधिक लागत, कम देखभाल, अधिक कठिनाई। NJ-7 बेहतर का हकदार है।',
    'accountability.cta': '#फाइंडिंगकीनफ्राइडेज में शामिल हों',

    // News Sources Section
    'news.title': '📰 और रसीदें',
    'news.updated': '2 मई, 2026 को अपडेट किया गया',
    'news.cbs': 'CBS News: लाखों लोग प्रीमियम वृद्धि का सामना कर रहे हैं',
    'news.wsj': 'WSJ: मेडिकेयर भुगतान स्थिर रखने पर बीमा कंपनियों की प्रतिक्रिया',
    'news.bloomberg': 'Bloomberg: स्वास्थ्य लागत गैस या किराने से ज्यादा चिंता',
    'news.nytimes': 'NY Times: 4 रिपब्लिकन ने वोट के लिए पार्टी से अलग हुए',
    'news.nytimes2': 'NY Times: हाउस ने ओबामाकेयर सब्सिडी विस्तार रोका',
    'news.nytimes3': 'NY Times: रिपब्लिकन ने डेमोक्रेट्स की पहल को अंतिम रेखा तक पहुंचाया',
    'news.cnn': 'CNN: अमेरिकी स्वास्थ्य देखभाल पर पहले से कहीं अधिक खर्च',
    'news.nytimes4': 'NY Times: ओबामाकेयर स्वास्थ्य बीमा में कटौती',
    'news.nytimes5': 'NY Times: कांग्रेस ने ओबामाकेयर सब्सिडी समाप्त होने दी, तब से लाखों लोग कवरेज छोड़ रहे हैं',

    // Footer
    'footer.tagline': 'सच्चाई दर्द देती है। झूठ की कीमत अधिक है। रिपब्लिकन को आपकी स्वास्थ्य देखभाल की परवाह नहीं है।',
    'footer.hashtags': '#कीनबेनकाब #नोकिंग्स #रिपब्लिकनकोपरवाहनहीं',
    'footer.disclaimer': 'सच्चाई दर्द देती है। झूठ की कीमत अधिक है। रिपब्लिकन को आपकी स्वास्थ्य देखभाल की परवाह नहीं है। #कीनबेनकाब #नोकिंग्स #RepublicansDontCareAboutYourHealthcare',
    'footer.terms': 'उपयोग की शर्तें',
    'footer.privacy': 'गोपनीयता नीति',
    'footer.contact': 'संपर्क',
};

export default hi;
